import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'components/ui'

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props)
        this.state = { hasError: false }
    }

    static getDerivedStateFromError() {
        return { hasError: true }
    }

    componentDidCatch(error, errorInfo) {
        console.error('Unhandled UI error:', error, errorInfo)
    }

    componentDidUpdate(prevProps) {
        if (this.state.hasError && prevProps.resetKey !== this.props.resetKey) {
            this.setState({ hasError: false })
        }
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="flex flex-col items-center justify-center h-full py-16 text-center">
                    <h4 className="mb-2">Something went wrong</h4>
                    <p className="mb-6">Please reload the page.</p>
                    <Button
                        size="sm"
                        variant="solid"
                        onClick={() => window.location.reload()}
                    >
                        Reload page
                    </Button>
                </div>
            )
        }

        return this.props.children
    }
}

ErrorBoundary.propTypes = {
    resetKey: PropTypes.any,
}

export default ErrorBoundary
